import { INDUSTRIES } from "@/lib/content";
import useSiteContent from "@/hooks/useSiteContent";

export default function Industries() {
  const cms = useSiteContent();
  const items = cms.industries?.length ? cms.industries : INDUSTRIES;
  return (
    <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="chapter-num">Industries We Serve</div>
        <h1 className="font-serif-display text-6xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-[0.95]">Sectors,<br /><em className="italic text-[var(--pta-gold)]">not silos.</em></h1>
        <p className="mt-8 max-w-2xl text-[var(--pta-ink)]/75 text-lg">A decade of working across sectors sharpens the advice. Below are the industries where we've built the deepest pattern-recognition.</p>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l hairline">
          {items.map((ind, i) => (
            <div key={ind.name} data-testid={`industry-${i}`} className="border-r border-b hairline p-8 group cursor-default">
              <div className="font-mono-fine text-[10px] tracking-[0.22em] text-[var(--pta-gold)]">SECTOR · {String(i + 1).padStart(2, "0")}</div>
              <h3 className="font-serif-display text-3xl text-[var(--pta-navy)] mt-3 group-hover:italic transition-all">{ind.name}</h3>
              <p className="mt-3 text-sm text-[var(--pta-ink)]/60">{ind.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
